import { connect } from 'react-redux'
import FeminineSpan from './FeminineSpan'
import { replaceText } from '../../actions/editor'


const mapStateToProps = state => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = dispatch => ({
    replaceText: editorState => {
        dispatch(replaceText(editorState))
    },
})

const FeminineSpanContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(FeminineSpan)

export default FeminineSpanContainer
